module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-8b7b3fe44f0984ddcf3610e093b4986d.jpg";